import { render, staticRenderFns } from "./_sistemico.vue?vue&type=template&id=467c25b5&scoped=true&"
import script from "./_sistemico.vue?vue&type=script&lang=js&"
export * from "./_sistemico.vue?vue&type=script&lang=js&"
import style0 from "./_sistemico.vue?vue&type=style&index=0&id=467c25b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467c25b5",
  null
  
)

export default component.exports